import { supabase } from "./supabase";

async function currentUserId() {
  const { data } = await supabase.auth.getUser();
  return data?.user?.id || null;
}

export async function getProfile() {
  const uid = await currentUserId();
  if (!uid) return null;
  const { data, error } = await supabase.from("profiles").select("*").eq("id", uid).maybeSingle();
  if (error) throw error;
  return data;
}

// Upsert partiel du profil de l'utilisateur courant (id = auth.uid()).
export async function upsertProfile(patch) {
  const uid = await currentUserId();
  if (!uid) throw new Error("no session");
  const row = { id: uid, ...patch, updated_at: new Date().toISOString() };
  const { data, error } = await supabase.from("profiles").upsert(row).select().single();
  if (error) throw error;
  return data;
}
